import { Pipe, PipeTransform } from '@angular/core';
import { getSimpleIdentifierFromString } from '../api/plyca-dtos';


@Pipe({
  name: 'simpleIdentifier'
})
export class SimpleIdentifierPipe implements PipeTransform {
  transform(identifier: string): string {
    return getSimpleIdentifierFromString(identifier);
  }
}
